<template>
  <form>
    <table class="my-5">
      <tr>
        <td class="bolder pb-3">{{num}}. <span v-html="$linebreak(question.question)"/></td>
      </tr>
      <tr>
        <td>
          <label>
            <input type="radio" :name="num"  @click="onCheck(1)" :checked="value==1"/>
            1) {{question.q1}}
          </label>
        </td>
      </tr>
      <tr>
        <td>
          <label>
            <input type="radio" :name="num" @click="onCheck(2)" :checked="value==2"/>
            2) {{question.q2}}
          </label>
        </td>
      </tr>
      <tr>
        <td>
          <label>
            <input type="radio" :name="num" @click="onCheck(3)" :checked="value==3"/>
            3) {{question.q3}}
          </label>
        </td>
      </tr>
      <tr>
        <td>
          <label>
            <input type="radio" :name="num" @click="onCheck(4)"  :checked="value==4"/>
            4) {{question.q4}}
          </label>
        </td>
      </tr>
    </table>
  </form>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'Question',
  components: {},
  props: ['num', 'question', 'value'],
  methods: {
    onCheck (i) {
      this.$emit('input', i)
    }
  }
}
</script>
<style scoped>
td {
  font-size: 16px;
}
</style>
